import { H3 } from '@berlitz/globals'
import RoleBasedView from '@components/RoleBasedView'
import Link from 'next/link'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import * as Scroll from 'react-scroll'
import { Row } from 'react-styled-flexboxgrid'
import IconMapping, { mappedIcons } from '../IconMapping'
import { ContactDashboardProps } from './interface'
import { ContentWrapper, StyledCard, StyledCol } from './style'

const ScrollLink = Scroll.Link

const ContactDashboard: React.FC<ContactDashboardProps> = ({ items, active }) => (
  <Row>
    {items.map(({ id, slug, title, action, icon }) => {
      icon = icon.toLowerCase()
      const CategoryComponent = (
        <StyledCol xs={12} md={6} lg={3} key={id} data-e2e={id}>
          <ScrollLink to="case-subtype" spy={true} smooth={true} duration={500}>
            <Link href={`/support/contact-us/?id=${slug}`} legacyBehavior>
              <div style={{ textDecoration: 'none', cursor: 'pointer' }}>
                <StyledCard active={slug === active} color={mappedIcons[icon] ? mappedIcons[icon][2] : 'purple'}>
                  <ContentWrapper>
                    <IconMapping icon={icon} />
                    <H3>
                      <FormattedMessage id={title} />
                    </H3>
                  </ContentWrapper>
                </StyledCard>
              </div>
            </Link>
          </ScrollLink>
        </StyledCol>
      )
      return action ? (
        <RoleBasedView key={id} configId={action}>
          {CategoryComponent}
        </RoleBasedView>
      ) : (
        CategoryComponent
      )
    })}
  </Row>
)

export default ContactDashboard
